import { createSlice } from "@reduxjs/toolkit";
import { PaginationResponse, ResponseData } from "api/types/_public";
import { IPool } from "api/types/_pool";
import { getOptionPools, getPools } from "./thunk";


export interface IState {
  pools: ResponseData<IPool[]> & PaginationResponse | null,
  isPoolLoading: boolean,
  isPoolSuccess: boolean,


  optionPools: ResponseData<IPool[]> & PaginationResponse | null,
  isOptionPoolLoading: boolean,
  isOptionPoolSuccess: boolean,

  error: any,
};

export const initialState: IState = {
  pools: null,
  isPoolLoading: false,
  isPoolSuccess: false,

  optionPools: null,
  isOptionPoolLoading: false,
  isOptionPoolSuccess: false,

  error: {},
};

const PoolSlice = createSlice({
  name: "Pool",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    //get pools
    builder.addCase(getPools.pending, (state: IState, action: any) => {
      state.isPoolLoading = true
    });
    builder.addCase(getPools.fulfilled, (state: IState, action: any) => {
      state.pools = action.payload;
      state.isPoolSuccess = true;
      state.isPoolLoading = false;
    });
    builder.addCase(getPools.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isPoolSuccess = false;
      state.isPoolLoading = false;
    });

    //get option pools
    builder.addCase(getOptionPools.pending, (state: IState, action: any) => {
      state.isOptionPoolLoading = true
    });
    builder.addCase(getOptionPools.fulfilled, (state: IState, action: any) => {
      state.optionPools = action.payload;
      state.isOptionPoolSuccess = true;
      state.isOptionPoolLoading = false;
    });
    builder.addCase(getOptionPools.rejected, (state: IState, action: any) => {
      state.error = action.payload.error || null;
      state.isOptionPoolSuccess = false;
      state.isOptionPoolLoading = false;
    });
  },
});

export default PoolSlice.reducer;